import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import spacing from 'src/constants/spacing';
import mediaQueries from 'src/constants/responsive';
import stylesheet from 'src/constants/stylesheet';
import Panels from './Panels';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            maxWidth: spacing.ContentMaxWidt,
            margin: '0 auto',
            boxSizing: 'content-box',
            [mediaQueries.Mobile]: {
                padding: '0 20px',
            },
            [mediaQueries.AfterMobile]: {
                padding: '0 60px',
            }
        },
        header: {
            padding: '2rem 0 1rem 0'
        },
        title: {
            ...stylesheet.TitleH1,
            textAlign: 'center',
            marginBottom: '.2em'
        },
        subTitle: {
            textAlign: 'center',
        },
        hr: {
            ...stylesheet.HR,
            // marginBottom: 13,
        },
        panels: {
            [mediaQueries.Mobile]: {},
            [mediaQueries.Tablet]: {
                marginLeft: -spacing.Gutter.Tablet / 2,
                marginRight: -spacing.Gutter.Tablet / 2,
            },
            [mediaQueries.Laptop]: {
                marginLeft: -spacing.Gutter.Laptop / 2,
                marginRight: -spacing.Gutter.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
        },
    }));

export type PageProps = PageDto;
type Props = PageProps;

const Page: FC<Props> = ({ Title, Panels: panels, Subtitle }) => {
    const cls = useStyles();

    return (
        <section className={cls.root}>
            <header className={cls.header}>
                {Title && <h1 className={cls.title}>{Title}</h1>}
                {Subtitle && <h5 className={cls.subTitle}>{Subtitle}</h5>}
            </header>
            <hr className={cls.hr} />
            <article className={cls.panels}>
                <Panels panels={panels} />
            </article>
        </section>
    );
}

export default Page;


// WEBPACK FOOTER //
// ./src/Components/Page.tsx